import { useTranslation } from 'react-i18next';

import { Highlighter, RowIndicators } from '@ifs-gcp/components';
import type { ChecklistRequirement, ValidationError } from '@ifs-gcp/core';

import { getTranslation } from '@/utils/translations';

type NumberCellProps = {
  row: ChecklistRequirement;
  language: string;
  search: string;
  error?: ValidationError[];
};

export const NumberCell = ({ row, language, search, error }: NumberCellProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Highlighter search={search} content={row.template.requirementNumber} />

      <RowIndicators
        isKo={row.template.isKo}
        errors={error?.map(({ error: singleError }) => getTranslation(singleError, language)) || []}
        texts={{
          ko: t('audit.checklist.ko'),
          warning: t('audit.checklist.warning'),
          validation: t('audit.checklist.validation'),
        }}
      />
    </>
  );
};
